module.exports = __webpack_public_path__ + "static/img/phone-call.d76872ac.png";